import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
  Card,
  CardContent,
  Paper,
} from "@mui/material";
import moment from "moment/moment";
import { useSwipeable } from "react-swipeable";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
// CSS
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./edit_card_v2.css";
import { CardHeader } from "@mui/material";
import { styled } from "@mui/system";
import ScrollableCreditCard from "./ScrollableCreditCard";
import FileUploadWithPreview from "./FileUploadWithPreview";

// component
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import { CustomInputText } from "../Component/CustomInputText";
import { CustomInputAutocomplete } from "../Component/CustomInputAutocomplete";
// services
import {
  getPersonalCardAPI,
  getUserProfileAPI,
  updatePersonalImageAPI,
  updatePersonalCardAPI,
  getIdNvAndAgeAPI,
} from "./PersonalService/personalService";
// icon
import icon_bank_card from "../../Icon/bank-card.png";
import { mockDataBankName } from "../BenefitReceivingHistory/mockData";
import Modal from "react-modal";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import iconSearch from "../../images/icon-search-2.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { Modal as BootstrapModal } from "react-bootstrap";
import greenCheck from "../../Icon/green-circle-check.png";
import remove from "../../images/remove.png";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import ArticleIcon from "@mui/icons-material/Article";
import { getPolicyInformationAPI } from "../PolicyList/PolicyListService/policyListService";
import CryptoJS from "crypto-js";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { requestOtpAPI } from "../changePay/changePayService/changePayService";
import { toast, ToastContainer } from "react-toastify";
import ContactModal from "../Component/ContactModal";

const EditCard2 = (props) => {
  let navigate = useNavigate();

  const refCarousel = useRef(null);

  const [cardStep, setCardStep] = useState(1);
  const [cardData, setCardData] = useState([]);
  const [selectedCard, setSelectedCard] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [relationOptions, setRelationOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [loading, setLoading] = useState(true); // for get profile, get card, save edit, save image
  const [loadingType, setLoadingType] = useState(true); // for get Type
  const [loadingRelation, setLoadingRelation] = useState(true); // for get relation
  const [loadingBank, setLoadingBank] = useState(true); // for get relation
  const [toggleImg, setToggleImg] = useState(false);

  const [fullName, setFullName] = useState();
  const [cardNumber, setCardNumber] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [type, setType] = useState();
  const [relation, setRelation] = useState();
  const [inputErrors, setInputErrors] = useState([]);

  const [dueDate, setDueDate] = useState();

  const [flagRelation, setFlagRelation] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [searchBasePolicy, setSearchBasePolicy] = useState("");
  const [option, setOption] = useState([]);
  const handleOpenModal = () => setOpenModal(true);
  const [activeDataModal, setActiveDataModal] = useState(0);
  const [completedModal, setCompletedModal] = useState(false);
  const [textModal, setTextModal] = useState("");

  const [selectedIndexes, setSelectedIndexes] = useState([]); 
  const [listData, setListData] = useState([]); 
  const [idnvFlag, setIdnvFlag] = useState(null);

  const [career, setCareer] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [fullNameRelate, setFullNameRelate] = useState();
  const [relationChk, setRelationChk] = useState("");
  const [openContactModal, setOpenContactModal] = useState(false);
  
  const fileDescriptions = [
    "รูปถ่ายหน้าบัตรเครดิต",
    "รูปถ่ายหน้าตรงที่เป็นปัจจุบันคู่บัตรประชาชน (ผู้เอาประกันภัย)",
    "สำเนาบัตรประชาชนด้านหน้า (เซ็นรับรองสำเนาถูกต้อง)",
  ];
  const fileDescriptionsFlagY = [
    "รูปถ่ายหน้าบัตรเครดิต",
    "รูปถ่ายหน้าตรงที่เป็นปัจจุบันคู่บัตรประชาชน (เจ้าของบัตรเครดิต)",
    "สำเนาบัตรประชาชนด้านหน้า (เซ็นรับรองสำเนาถูกต้อง) (เจ้าของบัตรเครดิต)",
  ];
  const fileDescriptionsIdnvYSelf = [
    "รูปถ่ายหน้าบัตรเครดิต",
  ];

  const [bank, setBank] = useState();
  const fileDescriptionsOption2 = [
    "รูปถ่ายหน้าบัตรเครดิต",
    "รูปถ่ายหน้าตรงที่เป็นปัจจุบันคู่บัตรประชาชน (ผู้เอาประกันภัย)",
    "รูปถ่ายหน้าตรงที่เป็นปัจจุบันคู่บัตรประชาชน (เจ้าของบัตรเครดิต)",
    "สำเนาบัตรประชาชนด้านหน้า (เซ็นรับรองสำเนาถูกต้อง) (เจ้าของบัตรเครดิต)",
  ];

  const [files, setFiles] = useState(Array(fileDescriptions.length).fill(null));
  const [checked, setChecked] = useState(false);

  const [inputData, setInputData] = useState([{}]);
  const [insureIdCard, setInsureIdCard] = useState(
    localStorage.getItem("customer_id")
  );
  const [dataPolicy, setDataPolicy] = useState([]);
  const [disableNext, setDisableNext] = useState(true);
  const [dataPolicies, setDataPolicies] = useState([]);

  const formatDate = (dateString) => {
    const date = new Date(dateString); 
    if (isNaN(date)) {
      return "-";
    }

    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const year = String(date.getFullYear()).slice(-2); 

    return `${month}/${year}`;
  };
  const styleDrive = {
    py: 0,
    width: "100%",
    maxWidth: "auto",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const decrypt = (cipher) => {
    const bytes = CryptoJS.AES.decrypt(
      cipher,
      process.env.REACT_APP_ENCRYPT_DATA
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const getPersonalCard = () => {
    setLoading(true);
    getPersonalCardAPI()
      .then((res) => {
        setLoading(false);
        if (res.success) {
          const trimPayload = res.payload.map((item) => {
            let newItem = {
              policy_no: item.policy_no ? item.policy_no.trim() : null,
              next_premium_due: item.next_premium_due
                ? item.next_premium_due.trim()
                : null,
              premium_amount: item.premium_amount ? item.premium_amount : null,
              card_holder_name: item.card_holder_name
                ? item.card_holder_name.trim()
                : null,
              card_number: item.card_number ? item.card_number.trim() : null,
              card_expire_date: item.card_expire_date
                ? item.card_expire_date.trim()
                : null,
              card_type: item.card_type ? item.card_type.trim() : null,
              credit_bank_name: item.credit_bank_name
                ? item.credit_bank_name.trim()
                : null,
              card_relation: item.card_relation
                ? item.card_relation.trim()
                : null,
            };
            return newItem;
          });
          let option = [];
          trimPayload.map((item, idx) => {
            let dataTmp = {
              label: item.policy_no,
              id: idx,
            };
            option.push(dataTmp);
          });
          setOption(option);
          setCardData(trimPayload);
          console.log(trimPayload);
          console.log(res.payload);
          // setCardData(trimPayload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        // setErrorCardData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const cardTypes = [
    { value: "AM", label: "Amex" },
    { value: "C4", label: "JCB" },
    { value: "MC", label: "Mastercard" },
    { value: "VI", label: "Visa" },
  ];

  const getType = () => {
    setLoadingType(true);
    setTimeout(() => {
      setLoadingType(false);
      setTypeOptions(cardTypes);
    }, 500);
  };

  const getCardTypeNameByCode = (code) => {
    const findCardType = cardTypes.find((item) => item.value === code);
    return findCardType ? findCardType.label : code;
  };

  const partialHide = (cardNumber) => {
    const hiddenCardNumber = cardNumber.split("");
    hiddenCardNumber.splice(4, 8, "********");
    return hiddenCardNumber.join("");
  };

  const getRelation = () => {
    setLoadingRelation(true);
    setTimeout(() => {
      setLoadingRelation(false);
      setRelationOptions([
        { value: "ตนเอง" },
        { value: "บิดา / มารดา" },
        { value: "สามี / ภรรยา" },
        { value: "บุตร" },
        { value: "พี่น้องร่วมสายโลหิต" },
      ]);
    }, 500);
  };

  const getBank = () => {
    setLoadingBank(true);
    setTimeout(() => {
      setLoadingBank(false);
      setBankOptions(mockDataBankName);
    }, 500);
  };

  const getBankNameCredit = async () => {
    const result = await getParameterAPI(23);
    if (result.success) {
      // console.log();
      const payload = result.payload;
      const formattedBanks = payload.map((bank) => `${bank.name}`);
      setLoadingBank(true);
      setTimeout(() => {
        setLoadingBank(false);
        // console.log(payload);
        setBankOptions(formattedBanks);
      }, 500);
    }
  };

  const getYear = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      let yearTemp = currentYear + i;
      years.push(yearTemp.toString().substring(2));
    }
    setYearOptions(years);
  };

  // ----- function for Step 2 upload file -----
  const validateCard = () => {
    const errors = [];
    if (!fullName) errors.push("input-full-name");
    if (!cardNumber) errors.push("input-card-number");
    if (!month) errors.push("input-month");
    if (!year) errors.push("input-year");
    if (!type) errors.push("input-type");
    if (!bank) errors.push("input-bank");
    if (!relation) errors.push("input-relation");
    if (relationChk && relationChk !== "ตนเอง") {
      if (!fullNameRelate) {
        errors.push("input-full-name-relate");
      }
    }
    setInputErrors(errors);
    if (errors.length > 0) {
      setToggleImg(false);
      setTextModal("กรุณากรอกข้อมูลให้ครบถ้วน");
      setCompletedModal(true);
    } else {
      // more validation about month/year must not past yet (card expired)
      let currentDate = new Date();
      let cardExpiredDate = new Date();
      cardExpiredDate.setMonth(Number(month) - 1);
      cardExpiredDate.setFullYear(
        Number(cardExpiredDate.getFullYear().toString().substring(0, 2) + year)
      );

      if (currentDate > cardExpiredDate) {
        setToggleImg(false);
        setTextModal("เดือน/ปี ของบัตรเครดิตหมดอายุ");
        setCompletedModal(true);
        errors.push("input-month-year");
        setInputErrors(["input-month-year"]);
      }
    }
    return errors;
  };

  const validateImage = () => {
    let error = false;
    let errorMessage = "";

    // ตรวจสอบว่าไม่มีไฟล์ใดเป็น null หรือ undefined
    // console.log(files);

    for (const f of files) {
      // console.log(f);

      if (f == null) {
        error = true;
        errorMessage =
          "เพื่อความรวดเร็วในการดำเนินการ โปรดแนบเอกสารให้ครบตามที่บริษัทฯ กำหนดค่ะ";
        break;
      }
    }

    // ถ้าไม่มี error ในขั้นต้น ให้ตรวจสอบประเภทไฟล์ต่อไป
    if (!error) {
      for (const file of files) {
        if (file && file.type) {
          // เพิ่มการตรวจสอบ file เป็น null/undefined
          const type = file.type;
          if (
            ![
              "image/jpeg",
              "image/jpg",
              "image/png",
              "application/pdf",
            ].includes(type)
          ) {
            error = true;
            errorMessage =
              "กรุณาอัพโหลดเอกสารนามสกุล .jpeg, .png, .pdf เท่านั้น";
            break;
          }
        } else {
          error = true;
          errorMessage = "ไฟล์บางไฟล์ไม่มีข้อมูลประเภท กรุณาอัพโหลดใหม่";
          break;
        }
      }
    }

    if (error) {
      setToggleImg(false);
      setTextModal(errorMessage);
      setCompletedModal(true);
    }

    return error;
  };

  const removeInputError = (inputId) => {
    setInputErrors((errors) => errors.filter((err) => err !== inputId));
  };

  const saveCardAndImage = async () => {
    let cardResponse = null; // ✅ ให้เห็นใน catch ได้

    try {
      setLoading(true);

      const errorsCard = validateCard();
      if (listData.length > 0 && errorsCard.length === 0) {
        const cardPayload = { policies: [] };
        listData.forEach((item) => {
          cardPayload.policies.push({
            policy_no: item.policy_no,
            card_holder_name: fullName,
            card_number: cardNumber,
            card_expire_date: `${month}/${year}`,
            card_type: type.value,
            credit_bank_name: bank,
            card_relation: relation.value,

            premium_amount: item.premium_amount,
            next_premium_due: item.next_premium_due,

            old_card_holder_name: item.card_holder_name || "",
            old_card_number: item.card_number || "",
            old_card_expire_date: item.card_expire_date || "",
            old_card_type: item.card_type?.value || "",
            old_credit_bank_name: item.credit_bank_name || "",
            otp: otp,
            card_relation_name: fullNameRelate,
          });
          setDueDate(item.next_premium_due);
        });

        // ✅ เปลี่ยนตรงนี้: ไม่ใช้ const ซ้ำ
        cardResponse = await updatePersonalCardAPI(cardPayload);

        if (!cardResponse.success) {
          throw new Error(cardResponse.payload.error);
        }


        const listID = cardResponse.result;
        const policy = listData.map((item) => item.policy_no).filter(p => p);

        console.log("listData:", listData);
        console.log("listID:", listID);
        console.log("policy:", policy);

        const formData = new FormData();

        files.forEach((file, index) => {
          if (file && file.name) {
            formData.append("files", file, file.name);
            formData.append("codeFile", index);
          } else {
            console.warn("Invalid file:", file);
          }
        });

        listID.forEach((id) => formData.append("listID", id));
        policy.forEach((p) => formData.append("policy", p));
        formData.append("type", 2);

        const imageResponse = await updatePersonalImageAPI(formData);
        if (!imageResponse.success) {
          throw new Error("ไม่สามารถบันทึกรูปภาพได้");
        }

        // สำเร็จ
        const dueDateFormat = moment(dueDate).format("DD/MM/YYYY");
        setToggleImg(true);
        setTextModal(
          "บริษัทได้รับคำขอเปลี่ยนแปลงจากท่านเรียบร้อยแล้ว หากท่านประสงค์ให้ตัดชำระเบี้ยในงวดปัจจุบัน โปรดติดต่อฝ่ายลูกค้าสัมพันธ์ 026483600"
        );
        setCompletedModal(true);
      } else {
        throw new Error("ข้อมูลไม่ถูกต้อง");
      }
    } catch (error) {
      console.error(error);
      setToggleImg(false);

      if (cardResponse?.payload?.error) {
        setTextModal(cardResponse.payload.error);
      } else {
        setTextModal(error.message || "เกิดข้อผิดพลาด");
      }

      setCompletedModal(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getUserProfileAPI()
      .then((res) => {
        const mockResponseGetUserProfileAPI = {
          payload: {
            error: "",
            type: "",
            profile: "Customer",
          },
          success: "true",
          act: false,
        };
        setLoading(false);
        if (res.success == "true") {
          if (res.payload.profile == "POS2") {
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });

    getPersonalCard();
    getType();
    getRelation();
    getBankNameCredit();
    getYear();
    getIdNvAndAgeAPI()
      .then((res) => {
        const flag = res?.data?.idnvFlag || "N";
        localStorage.setItem("idnvFlag", flag);
        setIdnvFlag(flag);
      })
      .catch((err) => {
        console.error(err);
        setIdnvFlag("N");
      });
    return () => {
    };
  }, []);
  useEffect(() => {
    if (idnvFlag === "Y") {
      if (flagRelation) {
        // กรณี idnvFlag = Y และเลือกความสัมพันธ์อื่น (ไม่ใช่ "ตนเอง")
        setFiles(Array(fileDescriptionsFlagY.length).fill(null));
      } else {
        // กรณี idnvFlag = Y และเลือก "ตนเอง" → แค่ 1 ไฟล์
        setFiles(Array(fileDescriptionsIdnvYSelf.length).fill(null));
      }
    } else {
      if (flagRelation) {
        setFiles(Array(fileDescriptionsOption2.length).fill(null));
      } else {
        setFiles(Array(fileDescriptions.length).fill(null));
      }
    }
  }, [relation, idnvFlag]);

  const breakPoints = [{ width: 1, itemsToShow: 1 }];

  const handleOwlChange = async (e) => {
    setActiveIndex(e);
    setActiveDataModal(e);
    setUpSelectCard(e);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSearchBasePolicy("");
  };

  const filteredOptions = option.filter((item) => {
    return searchBasePolicy.trim() === ""
      ? true
      : item.label.toLowerCase().includes(searchBasePolicy.toLowerCase());
  });

  const handleConfrimSearch = () => {
    setActiveIndex(activeDataModal);
    // updateDataPolicyActive(activeDataModal);
    handleCloseModal();
    setUpSelectCard(activeDataModal);
    // setUpSelectName(activeDataModal);
  };

  const renderOptionRow = (val, idx) => {
    const isActive = activeDataModal === idx;

    return (
      <div key={idx}>
        <Row
          onClick={!isActive ? () => handleSelectSearch(idx) : undefined}
          style={isActive ? { backgroundColor: "#FF5E43" } : {}}
          className={`gap-1 border-top border-bottom border-1 rounded-1 ${
            isActive ? "text-white" : "text-danger pointer"
          }`}
        >
          <Col className="px-3 d-flex flex-row justify-content-between">
            <span>{val.label}</span>
            {isActive && (
              <ArrowCircleLeftOutlinedIcon style={{ color: "white" }} />
            )}
          </Col>
        </Row>
      </div>
    );
  };
  const CustomCheckbox = styled(Checkbox)({
    color: "rgba(255, 94, 67, 0.5)",
    "&.Mui-checked": {
      color: "#FF5E43",
    },
    marginRight: "15px",
  });

  const handleSelectSearch = (idx) => {
    setActiveDataModal(idx);
  };

  const setUpSelectCard = (index) => {
    setSelectedCard((prev) => {
      let findName = prev.find(
        (i) => i.policy_no === cardData[index].policy_no
      );
      if (findName) {
        return prev.filter((ii) => ii.policy_no !== findName.policy_no);
      } else {
        return [...prev, cardData[index]];
      }
    });
  };

  useEffect(() => {
    if (cardData.length > 0) {
      setUpSelectCard(0);
    }
  }, [cardData]);

  const ScrollableCard = () => {
    const cardRef = React.useRef(null);

    const handlers = useSwipeable({
      onSwiped: (eventData) => {
        if (cardRef.current) {
          cardRef.current.scrollTop += -eventData.deltaY; // เลื่อนการ์ดตามการสไวป์ (ขึ้นหรือลง)
        }
      },
      delta: 10, // กำหนดความไวต่อการสไวป์
      trackMouse: true, // ทำให้ใช้เมาส์ในการลากได้
    });

    if (listData.length > 0) {
    }

    const handleBoxClick = (
      index,
      policy_no,
      old_card_holder_name,
      old_card_number,
      old_card_expire_date,
      old_card_type,
      old_credit_bank_name,
      premium_amount,
      next_premium_due,
      card_relation
    ) => {
      setSelectedIndexes(() => {
        if (selectedIndexes.includes(index)) {
          // ถ้าถูกเลือกแล้ว ให้ลบออกจาก array (ทำให้ไม่มีการเลือก)
          removeItemByPolicyNo(policy_no);
          return []; // ล้าง selectedIndexes
        } else {
          // ถ้ายังไม่ถูกเลือก ให้เพิ่มเข้าไปใน array (และล้างการเลือกก่อนหน้านี้)
          const updatedList = {
            policy_no: policy_no,
            card_holder_name: fullName,
            card_number: cardNumber,
            card_expire_date: month + "/" + year,
            card_type: type,
            credit_bank_name: bank,
            card_relation: relation,
            premium_amount: premium_amount,
            next_premium_due: next_premium_due,
            old_card_holder_name: old_card_holder_name || "",
            old_card_number: old_card_number || "",
            old_card_expire_date: old_card_expire_date || "",
            old_card_type: old_card_type || "",
            old_credit_bank_name: old_credit_bank_name || "",
            old_card_relation: card_relation || "",
            card_relation_name: fullNameRelate,
          };

          addItem(updatedList);
          return [index]; // เก็บ index ของรายการที่เลือกใหม่ (ล้าง index ก่อนหน้านี้)
        }
      });
    };

    const addItem = (newItem) => {
      setListData((prevListData) => [...prevListData, newItem]);
    };

    const removeItemByPolicyNo = (policyNo) => {
      setListData((prevListData) =>
        prevListData.filter((item) => item.policy_no !== policyNo)
      );
    };

    return (
      <Card
        sx={{
          maxHeight: "680px",
          overflowY: "hidden",
          border: "1px solid rgba(255, 94, 67, 0.3)", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
          borderRadius: "12px", // ความโค้งของขอบ
          borderWidth: "2px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        ref={cardRef}
        {...handlers} // ผูกฟังก์ชันสไวป์ให้กับการ์ด
      >
        <CardContent
          sx={{
            cursor: "pointer",
            overflowY: "auto", // เปิดการเลื่อนในแนวตั้ง
            boxSizing: "border-box",
          }}
        >
          {/* <Box>
            <FormControlLabel
              control={<CustomCheckbox onClick={handleCheckAll} checked={isChecked} />}
              label={<Typography style={{ fontSize: '20px' }}>ทุกกรมธรรม์</Typography>}
            />
          </Box> */}
          <Typography
            variant="body2"
            sx={{ color: "red", marginTop: "5px", marginLeft: "5px" }} // ข้อความสีแดงพร้อม margin ด้านบน
          >
            *กรุณาเลือกกรมธรรม์
          </Typography>

          {dataPolicies.map((_, index) => (
            <Box
              key={index}
              onClick={() =>
                handleBoxClick(
                  index,
                  _.policy_no,
                  _.card_holder_name,
                  _.card_number,
                  _.card_expire_date,
                  _.card_type,
                  _.credit_bank_name,
                  _.premium_amount,
                  _.next_premium_due,
                  _.card_relation
                )
              }
              sx={{
                marginBottom: "15px",
                padding: "10px",
                transition: "background-color 0.3s ease, border 0.3s ease",
                cursor: "pointer",
                alignItems: "center", // จัดให้ทุกอย่างอยู่กึ่งกลางในแนวตั้ง
                justifyContent: "space-between", // แยกข้อความทางซ้ายกับไอคอนทางขวา
                border: selectedIndexes.includes(index),
              }}
            >
              <Card
                style={{ zIndex: 1000 }}
                sx={{
                  backgroundColor: selectedIndexes.includes(index)
                    ? "rgba(255, 94, 67, 0.1)" // สีพื้นหลังเข้มเมื่อถูกเลือก
                    : "transparent", // พื้นหลังปกติ
                  transition: "background-color 0.3s ease, border 0.3s ease",
                }}
              >
                {/* <CardHeader title={"กรมธรรม์เลขที่ : " + _.policy_no} sx={{ backgroundColor: 'rgb(255, 94, 67,0.3)' }} /> */}
                <CardHeader
                  title={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CustomCheckbox
                        checked={selectedIndexes.includes(index)} // ทำการเช็คตาม selectedIndexes
                        onChange={(e) => {
                          // console.log("");
                          e.stopPropagation(); // หยุดไม่ให้เกิด event ที่ parent
                          // handleBoxClick(index, _.policy_no, _.address1, _.address2, _.address3, _.address4, _.address5, _.id); // ทำการคลิกเมื่อ checkbox ถูกเลือก
                        }}
                        sx={{ color: "rgba(255, 94, 67, 0.8)" }} // ปรับสี
                      />
                      <Box sx={{ marginLeft: "10px" }}>
                        {" "}
                        {/* เพิ่มระยะห่างระหว่าง checkbox และข้อความ */}
                        {"กรมธรรม์เลขที่ : " + _.policy_no}
                      </Box>
                    </Box>
                  }
                  sx={{
                    backgroundColor: "rgba(255, 94, 67, 0.3)", // ปรับให้ใช้งาน rgba ถูกต้อง
                  }}
                  titleTypographyProps={{
                    sx: {
                      fontFamily: '"Prompt-Thin", sans-serif !important',
                      fontSize: "15px",
                      color: "black",
                      marginLeft: "15px",
                    },
                  }}
                />

                <CardContent>
                  <Typography>
                    <Grid container spacing={1}>
                      {/* <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          
                        </span>
                      </Grid> */}
                      <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
                        <div
                          style={{
                            // display: 'flex',
                            flexDirection: "column", // ให้จัดเรียงข้อความในแนวตั้ง
                            whiteSpace: "normal", // ให้ตัดบรรทัดตามความยาวของเนื้อหา
                            wordBreak: "break-word", // ตัดคำเมื่อคำยาวเกินไป
                          }}
                        >
                          <span className="font-size-label-pol">
                            {`ชื่อ นามสกุล เจ้าของบัตรเครดิต : ${_.card_holder_name}`}
                          </span>
                        </div>
                      </Grid>
                    </Grid>

                    {/* <Grid container spacing={1}>
                      <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          หมายเลขบัตร :
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
                        <span className="font-size-label-pol">
                          {`${_.card_number}`}
                        </span>
                      </Grid>
                    </Grid> */}

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          หมายเลขบัตร :
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`${
                            _.card_number ? partialHide(_.card_number) : "-"
                          }`}
                        </span>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={11} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          เดือน/ปี หมดอายุของบัตร :
                        </span>
                      </Grid>
                      <Grid item xs={11} sm={7} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {/* {`${_.card_expire_date || "-"}`} */}
                          {formatDate(_.card_expire_date || "-")}
                        </span>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        sx={{
                          display: "flex",
                          justifyContent: "center", // จัดให้อยู่กึ่งกลางแนวนอน
                          alignItems: "center", // จัดให้อยู่กึ่งกลางแนวตั้ง
                        }}
                      >
                        {/* {selectedIndexes.includes(index) && (
                          <CheckCircleIcon
                            sx={{
                              color: 'rgba(255, 94, 67, 0.8)',
                            }}
                          />
                        )} */}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          ประเภทของบัตร :
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`${
                            _.card_type
                              ? getCardTypeNameByCode(_.card_type)
                              : "-"
                          }`}
                        </span>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                        <span className="font-size-label-pol">
                          ธนาคารเจ้าของบัตรเครดิต :
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`${
                            _.credit_bank_name === null
                              ? "-"
                              : _.credit_bank_name
                          }`}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={5} md={3} lg={4} xl={4}>
                        <span className="font-size-label-pol">
                          ความสัมพันธ์กับผู้เอาประกัน :
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`${_.card_relation == null ? "-" : _.card_relation}`}
                        </span>
                      </Grid>
                    </Grid>
                  </Typography>
                </CardContent>
              </Card>
              <Box></Box>
            </Box>
          ))}
        </CardContent>
      </Card>
    );
  };

  const ScrollableCardInformation = () => {
    const cardRef = React.useRef(null);

    const handlers = useSwipeable({
      onSwiped: (eventData) => {
        if (cardRef.current) {
          cardRef.current.scrollTop += -eventData.deltaY; // เลื่อนการ์ดตามการสไวป์ (ขึ้นหรือลง)
        }
      },
      delta: 10, // กำหนดความไวต่อการสไวป์
      trackMouse: true, // ทำให้ใช้เมาส์ในการลากได้
    });

    return (
      <Card
        sx={{
          maxHeight: "590px",
          overflowY: "hidden",
          border: "1px solid rgba(255, 94, 67, 0.3)", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
          borderRadius: "12px", // ความโค้งของขอบ
          borderWidth: "2px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        ref={cardRef}
        {...handlers} // ผูกฟังก์ชันสไวป์ให้กับการ์ด
      >
        <CardContent
          sx={{
            cursor: "pointer",
            overflowY: "auto", // เปิดการเลื่อนในแนวตั้ง
            boxSizing: "border-box",
          }}
        >
          {listData.map((_, index) => (
            <Box
              key={index}
              // onClick={() => handleBoxClick(index, _.policy_no, _.old_card_holder_name, _.old_card_number, _.old_card_expire_date, _.old_card_type, _.old_credit_bank_name, _.premium_amount, _.next_premium_due)}
              sx={{
                marginBottom: "15px",
                padding: "10px",
                transition: "background-color 0.3s ease, border 0.3s ease",
                cursor: "pointer",
                alignItems: "center", // จัดให้ทุกอย่างอยู่กึ่งกลางในแนวตั้ง
                justifyContent: "space-between", // แยกข้อความทางซ้ายกับไอคอนทางขวา
                border: selectedIndexes.includes(index),
              }}
            >
              <Card
                style={{ zIndex: 1000 }}
                sx={{
                  // backgroundColor: selectedIndexes.includes(index)
                  //   ? 'rgba(255, 94, 67, 0.1)' // สีพื้นหลังเข้มเมื่อถูกเลือก
                  //   : 'transparent', // พื้นหลังปกติ
                  transition: "background-color 0.3s ease, border 0.3s ease",
                }}
              >
                {/* <CardHeader title={"กรมธรรม์เลขที่ : " + _.policy_no} sx={{ backgroundColor: 'rgb(255, 94, 67,0.3)' }} /> */}

                <CardHeader
                  title={"กรมธรรม์เลขที่ : " + _.policy_no}
                  sx={{
                    backgroundColor: "rgba(255, 94, 67, 0.3)", // ปรับให้ใช้งาน rgba ถูกต้อง
                  }}
                  titleTypographyProps={{
                    sx: {
                      fontFamily: '"Prompt-Thin", sans-serif !important',
                      fontSize: "15px",
                      color: "black",
                      marginLeft: "15px",
                      // width: '50px !important',
                    },
                  }}
                />
                <CardContent>
                  <Typography>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
                        <div
                          style={{
                            // display: 'flex',
                            flexDirection: "column", // ให้จัดเรียงข้อความในแนวตั้ง
                            whiteSpace: "normal", // ให้ตัดบรรทัดตามความยาวของเนื้อหา
                            wordBreak: "break-word", // ตัดคำเมื่อคำยาวเกินไป
                          }}
                        >
                          <span className="font-size-label-pol">
                            {`ชื่อ นามสกุล เจ้าของบัตรเครดิต : ${_.card_holder_name}`}
                          </span>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`หมายเลขบัตร : ${
                            _.card_number ? partialHide(_.card_number) : "-"
                          }`}
                        </span>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={11} sm={7} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`เดือน/ปี หมดอายุของบัตร : ${
                            _.card_expire_date || "-"
                          }`}
                        </span>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`ประเภทของบัตร : ${
                            _.card_type
                              ? getCardTypeNameByCode(_.card_type.value)
                              : "-"
                          }`}
                        </span>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`ธนาคารเจ้าของบัตรเครดิต : ${
                            _.credit_bank_name === null
                              ? "-"
                              : _.credit_bank_name
                          }`}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                        <span className="font-size-label-pol">
                          {/* ******** */}
                          {`ความสัมพันธ์กับผู้เอาประกัน : ${
                            _.card_relation == null
                              ? "-"
                              : _.card_relation.value
                          }`}
                        </span>
                      </Grid>
                    </Grid>
                    {flagRelation && (
                      <Grid container spacing={1}>
                       
                        <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                          <span className="font-size-label-pol">
                            {`ชื่อ นามสกุล(ผู้มีความสัมพันธ์) : ${_.card_relation_name}`}
                          </span>
                        </Grid>
                      </Grid>
                    )}
                  </Typography>
                </CardContent>
              </Card>
              <Box></Box>
            </Box>
          ))}
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    getPolicyInformation();
    getPolicyInformationAll();
  }, []);

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getPolicyInformation = async () => {
    const result = await getPolicyInformationAPI(
      decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
    );
    if (result.status) {
      let option = [];
      await result.data.policies.map((item, idx) => {
        let data = {
          label: item.policyNo,
          id: idx,
        };
        option.push(data);
      });

      setDataPolicy(result.data.policies);
      await setOption(option);
    }
  };

  const resendOtp = () => {
    handleReqOtp();
  };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("EDIT_CARD");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  const getPolicyInformationAll = async () => {
    // setLoadingContent(true);
    const result = await getPolicyInformationAPI(decrypt(insureIdCard));
    if (result.status) {
      const filtered = result.data.policies.filter(
        (p) => p.policyFullyPaidFlag !== "Y"
      );
      setDataPolicies(filtered);
      console.log(result.data.policies);
    }
    // setLoadingContent(false);
  };

  return (
    <div className="edit-name">
      {loading ? (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      ) : null}
      <Header_Home />
      <Header title="เปลี่ยนบัตรเครดิต" />
      <div className="container-footer-space">
        <section
          className="update-receiving-address"
          style={{
            display: cardStep === 1 ? "block" : "none",
            marginBottom: "10px",
          }}
        >
          <div className="pb-2">
            <img
              className="name-document-icon"
              src={icon_bank_card}
              alt="name-document-icon"
            />
            <span className="bold">{"บัตรเครดิต"}</span>
          </div>
          <div className="px-4">
            <CustomInputText
              id="input-full-name"
              label="ชื่อ นามสกุล เจ้าของบัตรเครดิต"
              placeholder="ชื่อ นามสกุล เจ้าของบัตรเครดิต"
              value={fullName}
              onChange={(e) => {
                let formatValue = e.target.value
                  ? e.target.value.replace(/[^a-zA-Z\s]/g, "") 
                  : "";
                setFullName(formatValue);
                removeInputError("input-full-name");
              }}
              error={inputErrors.includes("input-full-name")}
            />

            <CustomInputText
              id="input-card-number"
              label="หมายเลขบัตร"
              placeholder="หมายเลขบัตร"
              value={cardNumber}
              onChange={(e) => {
                let formatValue = e.target.value
                  ? e.target.value.replace(/[^0-9]/g, "")
                  : "";
                if (formatValue.length <= 16) setCardNumber(formatValue);
                removeInputError("input-card-number");
              }}
              // onKeyDown={(e) => {
              //   if (!/[0-9]/.test(e.key)) {
              //     e.preventDefault();
              //   }
              // }}
              error={inputErrors.includes("input-card-number")}
            />

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <label
                  style={{
                    marginTop: "11px",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  เดือน/ปี หมดอายุของบัตร
                </label>
              </Grid>

              <Grid item xs={5}>
                <CustomInputAutocomplete
                  id="input-month"
                  // label=""
                  placeholder="เดือน"
                  value={month}
                  style={{ marginTop: "-10px" }}
                  onChange={(value) => {
                    setMonth(value);
                    removeInputError("input-month");
                  }}
                  options={[
                    "01",
                    "02",
                    "03",
                    "04",
                    "05",
                    "06",
                    "07",
                    "08",
                    "09",
                    "10",
                    "11",
                    "12",
                  ]}
                  error={
                    inputErrors.includes("input-month") ||
                    inputErrors.includes("input-month-year")
                  }
                  errorText={
                    inputErrors.includes("input-month-year")
                      ? "บัตรหมดอายุ"
                      : undefined
                  }
                />
              </Grid>
              <Grid item xs={1}>
                <div style={{ paddingTop: "40px", marginTop: "-30px" }}>/</div>
              </Grid>
              <Grid item xs={5}>
                <CustomInputAutocomplete
                  id="input-year"
                  label=" "
                  placeholder="ปี"
                  value={year}
                  onChange={(value) => {
                    setYear(value);
                    removeInputError("input-year");
                  }}
                  options={yearOptions}
                  error={
                    inputErrors.includes("input-year") ||
                    inputErrors.includes("input-month-year")
                  }
                  style={{ marginTop: "-10px" }}
                  errorText={
                    inputErrors.includes("input-month-year") ? " " : undefined
                  }
                />
              </Grid>
            </Grid>
            <CustomInputAutocomplete
              id="input-type"
              label="ประเภทของบัตร"
              placeholder="กรุณาเลือก"
              value={type}
              onChange={(value) => {
                setType(value);
                removeInputError("input-type");
              }}
              options={typeOptions || []}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              loading={loadingType}
              error={inputErrors.includes("input-type")}
            />

            <CustomInputAutocomplete
              id="input-bank"
              label="ธนาคารเจ้าของบัตรเครดิต"
              placeholder="กรุณาเลือก"
              value={bank}
              onChange={(value) => {
                setBank(value);
                removeInputError("input-bank");
              }}
              options={bankOptions || []}
              loading={loadingBank}
              error={inputErrors.includes("input-bank")}
            />
            {/* <CustomInputText
              id="input-bank"
              label="ธนาคารเจ้าของบัตรเครดิต"
              placeholder="ธนาคารเจ้าของบัตรเครดิต"
              value={bank}
              onChange={(e) => {
                setBank(e.target.value);
                removeInputError("input-bank");
              }}
            /> */}
            <>
              <>
                <CustomInputAutocomplete
                  id="input-relation"
                  label={
                    <span className="multiline-label">
                      ความสัมพันธ์กับผู้เอาประกัน
                    </span>
                  }
                  placeholder="กรุณาเลือก"
                  value={relation}
                  onChange={(value) => {
                    if (!value || !value.value) {
                      setFlagRelation(false);
                      setRelation(null);
                      return;
                    }

                    if (value.value === "ตนเอง") {
                      setFlagRelation(false);
                    } else {
                      setFlagRelation(true);
                    }

                    setRelation(value);
                    setRelationChk(value.value);
                    removeInputError("input-relation");
                  }}
                  options={relationOptions || []}
                  getOptionLabel={(option) => option.value}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  loading={loadingRelation}
                  error={inputErrors.includes("input-relation")}
                />

                {flagRelation && (
                  <CustomInputText
                    id="input-full-name-relate"
                    label="ชื่อ นามสกุล"
                    placeholder="ชื่อ นามสกุล"
                    value={fullNameRelate}
                    onChange={(e) => {
                      setFullNameRelate(e.target.value);
                      removeInputError("input-full-name-relate");
                    }}
                    error={inputErrors.includes("input-full-name-relate")}
                  />
                )}
              </>
            </>

            <Grid item xs={12} sm={5} md={3} lg={4} xl={4}>
              <Typography
                variant="body2"
                sx={{ color: "red", marginTop: "5px", marginLeft: "5px" }} // ข้อความสีแดงพร้อม margin ด้านบน
              >
                *บริษัทฯ จะเก็บรวบรวม ใช้ หรือ
                เปิดเผยข้อมูลส่วนบุคคลที่ได้รับจากท่าน (เจ้าของบัตรเครดิต)
                เพื่อเรียกเก็บค่าเบี้ยประกันภัย หรือคืนเงินค่าเบี้ยประกันภัย
                ตามนโยบายความเป็นส่วนตัวสำหรับลูกค้าของบริษัทฯ ที่ปรากฏบน
                website www.rabbitlife.co.th
              </Typography>
            </Grid>
          </div>
        </section>

        <Box
          sx={{
            display: cardStep === 3 ? "flex" : "none",
            alignItems: "center",
          }}
          style={{ marginBottom: "10px" }}
        >
          <AssignmentTurnedInRoundedIcon
            fontSize={"large"}
            style={{ color: "rgb(255, 94, 67)" }}
          />
          <Typography style={{ fontSize: "20px", marginLeft: "10px" }}>
            ยืนยันข้อมูล
          </Typography>
        </Box>

        {cardStep === 1 ? (
          <ScrollableCreditCard
            listData={listData}
            cardData={cardData}
            setListData={setListData}
            fullName={fullName}
            cardNumber={cardNumber}
            month={month}
            year={year}
            type={type}
            bank={bank}
            relation={relation}
            inputErrors={inputErrors}
            dataPolicy={dataPolicies}
            fullNameRelate={fullNameRelate}
            dataPolicies={dataPolicies}
          />
        ) : cardStep === 3 ? (
          <ScrollableCardInformation />
        ) : cardStep === 4 ? (
          <Box sx={{ p: 1, margin: "auto" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                display: "flex",
                alignItems: "center",
                fontFamily: "Prompt-Thin",
              }}
            >
              <VerifiedUserIcon sx={{ color: "#FF5E43", mr: 1 }} />
              ยืนยัน OTP
            </Typography>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                p: 3,
                mb: 3,
                textAlign: "center",
              }}
            >
              <Typography sx={{ mb: 2, textAlign: "left" }}>
                กรุณาใส่หมายเลข OTP 6 หลัก
                <br />
                ที่ส่งไปยังเบอร์มือถือของท่าน
              </Typography>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="OTP"
                maxLength={6}
                value={otp}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setOtp(onlyNums);
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "30px",
                  border: "1px solid #ccc",
                  fontSize: 18,
                  width: "100%",
                  outline: "none",
                  marginBottom: 8,
                }}
              />
              <div
                style={{
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "flex-start", // ✅ ให้ชิดซ้าย
                  width: "100%",
                  marginTop: 10,
                }}
              >
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }} // ✅ กันพลาดเพิ่ม textAlign ด้วย
                >
                  ส่งรหัสผ่านไปที่หมายเลข{" "}
                  {localStorage.getItem("mobile_tel")
                    ? localStorage
                        .getItem("mobile_tel")
                        .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                    : ""}
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรุณา
                  <span
                    onClick={() => setOpenContactModal(true)}
                    style={{
                      color: "#FF5E43",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ติดต่อฝ่ายลูกค้าสัมพันธ์
                  </span>
                </div>
              </div>

              <Typography
                sx={{
                  color: "#f2654e",
                  fontSize: 14,
                  mt: 1,
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onClick={resendOtp}
              >
                ส่งรหัส OTP อีกครั้ง?
              </Typography>
            </Paper>
          </Box>
        ) : (
          <section
            className="upload-image-address"
            style={{ display: cardStep === 2 ? "block" : "none" }}
          >
            <div className="address-image-card">
              <ul className="list-group list-group-flush">
                <div className="address-card-title">{"อัพโหลดไฟล์"}</div>
                <hr className="line" />
                {idnvFlag !== null && <FileUploadWithPreview
                  flagRelation={flagRelation}
                  setFiles={setFiles}
                  fileDescriptions={fileDescriptions}
                  files={files}
                  fileDescriptionsOption2={fileDescriptionsOption2}
                  fileDescriptionsFlagY={fileDescriptionsFlagY}
                  fileDescriptionsIdnvYSelf={fileDescriptionsIdnvYSelf}
                  idnvFlag={idnvFlag}
                />}
              </ul>
            </div>
          </section>
        )}

        <br />
        {cardStep === 1 && (
          <Box
            sx={{
              borderRadius: 2,
              p: 2,
              maxWidth: 1100,
            }}
          >
            {/* หัวข้อ */}
            <Box display="flex" alignItems="center" mb={1}>
              <ArticleIcon sx={{ color: "#f44336", mr: 1 }} />
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", color: "#f44336" }}
                style={{ fontFamily: "Prompt-Thin" }}
              >
                ข้อกำหนดและเงื่อนไข
              </Typography>
            </Box>

            {/* เนื้อหา */}
            <Typography
              style={{ fontFamily: "Prompt-Thin" }}
              variant="body2"
              color="textSecondary"
              paragraph
            >
              ข้าพเจ้ายืนยันว่าบัตรเครดิตที่ใช้ชำระเบี้ยประกันของข้าพเจ้า
              หรือบุคคลในครอบครัว ได้แก่ บิดามารดา สามีภรรยา บุตร
              และญาติพี่น้องของข้าพเจ้า
              และขอยืนยันว่าข้าพเจ้าได้รับความยินยอมจากบุคคลดังกล่าวให้นำบัตรเครดิต
              มาใช้เพื่อชำระค่าเบี้ยประกันภัยแล้ว
              หากต่อมามีข้อเท็จจริงปรากฏแก่บริษัทฯ
              ในภายหลังว่าบุคคลซึ่งเป็นเจ้าของบัตรเครดิตมิได้
              ให้ความยินยอมในการใช้บัตรดังกล่าว ข้าพเจ้ายินยอมให้บริษัทฯ
              ยกเลิกกรมธรรม์
              และรับทราบว่าการยกเลิกดังกล่าวอาจจะส่งผลกระทบต่อสถานะกรมธรรม์ของข้าพเจ้า
              ทั้งนี้ หากปรากฏความเสียหายอย่างใดเกิดขึ้นกับบริษัท
              ข้าพเจ้ายินยอมรับทราบว่าบริษัทฯ
              จะสงวนสิทธิ์ในการดำเนินคดีตามกฎหมายต่อไป
            </Typography>

            {/* Checkbox */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setChecked(isChecked);
                    setDisableNext(!isChecked);
                  }}
                  sx={{
                    color: "#f44336",
                    "&.Mui-checked": { color: "#f44336" },
                  }}
                />
              }
              label={
                <Typography sx={{ fontWeight: checked ? "bold" : "normal" }}>
                  ข้าพเจ้าได้อ่านและยอมรับข้อกำหนดและเงื่อนไขข้างต้นแล้ว
                </Typography>
              }
            />
          </Box>
        )}

        <br />
        <section className="action-address">
          <Grid
            container
            spacing={2}
            justifyContent="center" // จัดตำแหน่งตรงกลางแนวนอน
            alignItems="center" // จัดตรงกลางแนวตั้ง
            sx={{ minHeight: "10vh" }} // ให้ Grid เต็มความสูงหน้าจอ
          >
            <Grid item xs={12} sm={6} md={2}>
              <button
                onClick={() => {
                  if (cardStep === 1) {
                    // exit page or back step
                    navigate(-1);
                  } else if (cardStep === 3) {
                    setCardStep(cardStep - 2);
                  } else if (cardStep === 4) {
                    setCardStep(3);
                  } else {
                    setCardStep(cardStep - 1);
                  }
                }}
                className="btn-address-back w-100 p-2 bold"
              >
                ย้อนกลับ
              </button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <button
                style={{ fontSize: 18 }}
                onClick={() => {
                  if (cardStep === 1) {
                    let errorsCard = validateCard();
                    if (errorsCard.length === 0) {
                      if (listData.length === 0) {
                        // setOpenErrorMissingCard(true);
                        setToggleImg(false);
                        setTextModal(
                          "กรุณาเลือกกรมธรรม์ที่ต้องการแจ้งเปลี่ยนบัตรเครดิต"
                        );
                        setCompletedModal(true);
                        // refCarousel.current.scrollIntoView();
                      } else {
                        setCardStep(2);
                      }
                    }
                    // }
                  } else if (cardStep === 2) {
                    const errorImage = validateImage();

                    if (!errorImage) {
                      setCardStep(3);
                    }
                  } else if (cardStep === 3) {
                    handleReqOtp();
                    setCardStep(4);
                  } else {
                    saveCardAndImage();
                  }
                }}
                className={`btn-address-next w-100 p-2 bold ${
                  cardStep === 1 && !disableNext ? "btn-disabled" : ""
                }`}
                disabled={disableNext}
              >
                {cardStep <= 3 ? "ต่อไป" : "บันทึก"}
              </button>
            </Grid>
          </Grid>
        </section>
      </div>
      <Modal
        isOpen={openModal}
        onRequestClose={handleCloseModal}
        contentLabel="ModalPolicy"
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className="p-lg-2 p-3">
          <h3 style={{ color: "#FA0E0E", fontSize: "18px" }}>กรมธรรม์เลขที่</h3>
          <div className="d-grid mb-4">
            <TextField
              type="text"
              size="small"
              onChange={(e) => handleSearchBasePolicy(e.target.value)}
              className=""
              value={searchBasePolicy}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={iconSearch} height={20} width={20} alt="" />
                  </InputAdornment>
                ),
              }}
              sx={{
                backgroundColor: "#FFF",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  height: "35px",
                  "& fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&:hover fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#FB5E3F",
                  },
                },
              }}
            />
          </div>
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {!filteredOptions.length == 0 ? (
              filteredOptions.map(renderOptionRow)
            ) : (
              <div className="text-center text-muted">
                ไม่มีข้อมูลที่ตรงกับการค้นหา
              </div>
            )}
          </div>
          <Row className="d-flex flex-row justify-content-evenly mt-3">
            {/* <Col className="bg-danger"> */}
            <button
              style={{ fontSize: 15 }}
              onClick={handleConfrimSearch}
              className="btn-checkout-premium w-25 p-2 bold"
            >
              ตกลง
            </button>
            <button
              style={{ fontSize: 15 }}
              onClick={handleCloseModal}
              className="btn-checkout-back w-25 p-2 bold"
            >
              ยกเลิก
            </button>
          </Row>
        </div>
      </Modal>
      <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="font-modal">{textModal}</div>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
    </div>
  );
};

export default EditCard2;
